<template>
    <div class="spec-info-body">
		<p>规格设置</p>
		<div v-if="!matchbillcenterflag" class="set-box">
			<div class="spec-btn" @click="addSpecSKU" v-if="SKUType.length < 3 && !editDisable">新增规格名称</div>
			<div class="spec-btn-disabled" v-if="SKUType.length === 3 && !editDisable">新增规格名称</div>
			<div class="sku-box" v-for="(item, index) in SKUType" :key="item.patid">
				<div class="sku-title">{{item.patname}}</div>
				<div>
					<div class="sku-set-box">
						<div class="spec-btn" v-if="!editDisable" @click="addSKUValue(item.patid, index,item.patname)">添加规格数值</div>
						<div class="spec-btn" v-if="!editDisable" @click="deleteSKU(item.patid,item.patname)">删除规格名称</div>
					</div>
					<div class="sku-name-box">
						<div v-for="valueItem in item.specvalue" :key="valueItem.pavid">{{valueItem.pavname}}<i class="el-icon-circle-close delete-sku" v-if="!editDisable" @click="deleteValue(valueItem.pavid, item.specvalue.length, item.patid, index, item.patname, valueItem.pavname)"></i></div>
					</div>
				</div>
			</div>
		</div>
		<div v-else class="set-box">
			<div class="sku-box sku-match-box" v-for="item in SKUType" :key="item.patid">
				<div class="sku-title">{{item.patname}}</div>
				<div>
					<div class="sku-name-box">
						<div v-for="valueItem in item.specvalue" :key="valueItem.pavid">{{valueItem.pavname}}</div>
					</div>
				</div>
			</div>
		</div>
		<p>规格明细</p>
		<div>
			<div class="features-btn-box">
				<el-button v-if="!editDisable && relAllShopFlag === 0 && chooseShop.length < 2" type="primary" size='small' class="fx-big-btn" plain @click="setDisableFlag(0)">可售</el-button>
				<el-button v-if="!editDisable && relAllShopFlag === 0 && chooseShop.length < 2" type="primary" size='small' class="fx-big-btn" plain @click="setDisableFlag(1)">停售</el-button>
				<!-- <el-button v-if="!editDisable && freightType !== 1 && !stopFlag" type="primary" size='small' class="fx-big-btn" plain @click="setFreightMuti">批量设置运费</el-button> -->
			</div>
			<div class="table-box">
				<el-table
					:stripe='false'
					class="grid-content goods-table"
					:data="tableData"
					size='mini'
					max-height="400"
					border
					:row-class-name="tableRowClassName"
					@selection-change="handleSelectionChange">
					<el-table-column
					type="selection"
					align="center"
					width="55">
					</el-table-column>
					<el-table-column
						prop="url"
						key="url"
						align="center"
						min-width="120">
						<template slot="header">
							<div class="title-box">规格图片
								<el-tooltip class="item" effect="dark" content="图片尺寸最优比例80*80，1M以内，格式：JPG /JPEG / PNG/GIF" placement="top-start">
									<img src="~/images/icon/tooltip-icon.png" class="spec-title">
								</el-tooltip>
							</div>
						</template>
						<template slot-scope="scope">
							<div class="goods-table-info">
								<ImgUplaod
									:canEdit='!editDisable'
									class="show-img"
									:imgSrc.sync="scope.row.url"
									:imgId.sync="scope.row.id"
									:imgIndex.sync="scope.$index"
									:uploadError.sync="uploadError"
									@preview="preview"
									@updateImg="updateImg"
									ref="showUpload"
								/>
							</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="bcname"
						key="bcname"
						label="规格名称"
						align="center"
						min-width="180">
						<template>
							<div>
								{{nameName}}
							</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="spec"
						key="spec"
						label="规格数值"
						align="center"
						min-width="180">
					</el-table-column>
					<!-- <el-table-column
						prop="usesystemfreightflag"
						key="usesystemfreightflag"
						v-if="freightType !== 1 && !stopFlag"
						label="配送计费方式"
						align="center"
						min-width="180">
						<template slot-scope='scope'>
							<span>{{scope.row.usesystemfreightflag ? '按重量' : '按件数'}}</span>
							<el-button style="margin-left: 10px;" size="mini" type="text" @click='showFreightClick(scope.row.productPlanId)' >规则</el-button>
						</template>
					</el-table-column> -->
					<el-table-column
						prop="unit"
						key="unit"
						v-if="matchbillcenterflag"
						label="订货单位"
						align="center"
						min-width="180">
						<template slot-scope='scope'>
							<el-button size="mini" type="text" @click='showUnitClick(scope.row.productPlanId)' >查看</el-button>
						</template>
					</el-table-column>
					<el-table-column
						prop="matchcode"
						key="matchcode"
						label="第三方编号"
						v-if="matchbillcenterflag"
						align="center"
						min-width="180">
						<template slot-scope='scope'>
							<div>
								<el-input disabled v-model="scope.row.matchcode" size="mini"></el-input>
							</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="code"
						key="code"
						label="规格编号"
						align="center"
						min-width="200">
						<template slot-scope='scope'>
							<div>
								<el-input :disabled="matchbillcenterflag || editDisable" :maxlength='18' v-model="scope.row.code" @input="codeInput(scope.$index)" size="small"></el-input>
							</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="matchprice"
						key="matchprice"
						label="中台价"
						v-if="matchbillcenterflag"
						align="center"
						min-width="200">
						<template slot-scope='scope'>
							<div>
								<el-input disabled :maxlength='18' v-model="scope.row.matchprice" size="mini"></el-input>
							</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="price"
						label="销售价"
						key="price"
						align="center"
						min-width="180">
							<template slot="header">
								<div class="title-box">销售价
									<el-tooltip class="item" effect="dark" content="如果开启了辅助单位,则辅助单位的售价 = 规格销售价 * 辅助单位换算系数" placement="top-start">
										<img src="~/images/icon/tooltip-icon.png" class="spec-title">
									</el-tooltip>
								</div>
							</template>
							<template slot-scope='scope'>
								<div v-if="!matchbillcenterflag" class="table-price">
									<div class="price-input">
										<div class="price-title">自定</div>
										<el-input :disabled="editDisable" v-model="scope.row.price" @blur="priceBlur(scope.$index)" size="mini"></el-input>
									</div>
									<span>元</span>
								</div>
								<div v-if="matchbillcenterflag" class="table-price">
									<div class="price-input">
										<el-input :disabled="editDisable" v-model="scope.row.price" @blur="priceBlur(scope.$index)" size="mini"></el-input>
									</div>
									<span>元</span>
								</div>
							</template>
					</el-table-column>
					<el-table-column
						prop="costprice"
						label="成本价"
						v-if="costshowflag === 1"
						key="costprice"
						align="center"
						min-width="180">
							<template slot="header">
								<div class="title-box">成本价
									<el-tooltip class="item" effect="dark" content="如果开启了辅助单位,则辅助单位的成本价 = 规格成本价 * 辅助单位换算系数" placement="top-start">
										<img src="~/images/icon/tooltip-icon.png" class="spec-title">
									</el-tooltip>
								</div>
							</template>
							<template slot-scope='scope'>
								<div class="table-price">
									<div class="price-input">
										<el-input :disabled="editDisable" v-model="scope.row.costprice" @blur="costpriceBlur(scope.$index)" size="mini"></el-input>
									</div>
									<span>元</span>
								</div>
							</template>
					</el-table-column>
					<el-table-column
						prop="weight"
						key="weight"
						label="重量"
						align="center"
						min-width="160">
							<template slot-scope='scope'>
								<div class="table-weight">
									<el-input :disabled="editDisable" v-model="scope.row.weight" size="mini" @blur="weightBlur(scope.$index)"></el-input><span>KG</span>
								</div>
							</template>
					</el-table-column>
				<!-- 	<el-table-column
						v-if="!matchbillcenterflag || (!actualtimeinventoryflag && matchbillcenterflag)"
						prop="inventory"
						key="inventory"
						label="库存"
						min-width="120"
						align="center">
						<template slot="header">
							<div style="position:relative">库存
								<el-tooltip class="item" effect="dark" content="如果开启了辅助单位,则买家小程序显示的辅助单位的库存 = 最小单位库存/辅助单位换算系数(2位小数以上直接抹零)" placement="top-start">
									<img src="~/images/icon/tooltip-icon.png" class="spec-title">
								</el-tooltip>
							</div>
						</template> -->
							<!-- <template slot-scope='scope'>
								<div>
									<el-input v-model="scope.row.inventory" @input="inventoryBlur(scope.$index)" size="small"></el-input>
								</div>
							</template> -->
					<!-- </el-table-column> -->
					<el-table-column
						prop="maxBuyQuantity"
						key="maxBuyQuantity"
						label="最大订货量"
						v-if="relAllShopFlag === 0 && chooseShop.length === 1"
						align="center"
						min-width="320">
							<template slot="header">
								<div class="title-box">最大订货量
									<el-tooltip class="item" effect="dark" content="最大订货量输入空为不限制" placement="top-start">
										<img src="~/images/icon/tooltip-icon.png" class="spec-title">
									</el-tooltip>
								</div>
							</template>
							<template slot-scope='scope'>
								<div style="display:flex;align-items:center;">
									<el-input :disabled="editDisable" style="width:90px;flex-shrink:0;margin-right:10px;" v-model="scope.row.maxBuyQuantity" size="small" @input="maxBuyQuantityInput2(scope.$index)" @blur="maxBuyQuantityBlur2(scope.$index)"></el-input>
									<el-radio v-model="scope.row.maxbuyquantityflag" :label="0">每天总量</el-radio>
									<el-radio v-model="scope.row.maxbuyquantityflag" :label="1">每客户每天</el-radio>
								</div>
							</template>
					</el-table-column>
					<el-table-column
						prop="minbuycnt"
						key="minbuycnt"
						label="最小起订量"
						v-if="relAllShopFlag === 0 && chooseShop.length === 1"
						align="center"
						min-width="150">
						<template slot="header">
							<div class="title-box">最小起订量
								<el-tooltip class="item" effect="dark" content="如果开启了辅助单位,则辅助单位的最小起订量" placement="top-start">
									<img src="~/images/icon/tooltip-icon.png" class="spec-title">
								</el-tooltip>
							</div>
						</template>
							<template slot-scope='scope'>
								<div>
									<el-input :disabled="editDisable" v-model="scope.row.minbuycnt" size="small" @input="minbuycntInput2(scope.$index)" @blur="minbuycntBlur2(scope.$index)"></el-input>
								</div>
							</template>
					</el-table-column>
					<el-table-column
						prop="barcodecount"
						key="barcodecount"
						label="条形码"
						align="center"
						min-width="130">
						<template slot-scope='scope'>
							<div class="qrcode-btn" @click="qrClick(scope.row.spec, scope.row.productPlanId, scope.$index)">编辑<span class="qrcode-color">（{{scope.row.barcodecount}}个）</span></div>
						</template>
					</el-table-column>
					<el-table-column
						prop="defaultflag"
						key="defaultflag"
						label="默认规格"
						align="center"
						min-width="120">
							<template slot-scope='scope'>
								<el-radio :disabled="editDisable" v-model="scope.row.defaultflag" :label="true" @change="changeDefault(scope.$index)">默认</el-radio>
							</template>
					</el-table-column>
					<el-table-column
						prop="seqnum"
						key="seqnum"
						label="展示顺序"
						align="center"
						min-width="160">
							<template slot-scope='scope'>
								<div class="seqnum-actions">
									<i
										class="el-icon-upload2"
										title="置顶"
										:class="{ 'is-disabled': editDisable || scope.$index === 0 }"
										@click="moveSpec(scope.$index, 'top')"
									></i>
									<i
										class="el-icon-top"
										title="上移"
										:class="{ 'is-disabled': editDisable || scope.$index === 0 }"
										@click="moveSpec(scope.$index, 'up')"
									></i>
									<i
										class="el-icon-bottom"
										title="下移"
										:class="{ 'is-disabled': editDisable || scope.$index === tableData.length - 1 }"
										@click="moveSpec(scope.$index, 'down')"
									></i>
									<i
										class="el-icon-download"
										title="置底"
										:class="{ 'is-disabled': editDisable || scope.$index === tableData.length - 1 }"
										@click="moveSpec(scope.$index, 'bottom')"
									></i>
								</div>
							</template>
					</el-table-column>
					<el-table-column
						prop="disabledflag"
						key="disabledflag"
						label="可售状态"
						v-if="relAllShopFlag === 0 && chooseShop.length === 1"
						align="center"
						min-width="180">
							<template slot-scope='scope'>
								<el-radio :disabled="editDisable" v-model="scope.row.disabledflag" :label="false">可售</el-radio>
								<el-radio :disabled="editDisable" v-model="scope.row.disabledflag" :label="true">停售</el-radio>
							</template>
					</el-table-column>
					<el-table-column
						prop="operation"
						key="operation"
						label="操作"
						v-if="!(relAllShopFlag === 0 && chooseShop.length === 1)"
						align="center"
						min-width="180">
							<template slot-scope='scope'>
								<el-button type="primary" :disabled="editDisable" size='small' class="fx-big-btn" @click="diySet(scope.row, scope.$index)">自定义设置</el-button>
							</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<el-dialog title="自定义设置" class="dialog-title" :visible.sync="diySetModal" width='1200px' :close-on-click-modal="false">
			<el-table
				:stripe='false'
				class="grid-content goods-table"
				:data="diySetData"
				:row-style="rowShowStyle"
				size='mini'
				max-height="400"
				border>
				<el-table-column
					prop="shopname"
					label="店铺"
					align="center"
					min-width="120">
				</el-table-column>
				<el-table-column
					prop="maxBuyQuantity"
					label="最大订货量"
					align="center"
					min-width="180">
						<template slot="header">
							<div class="title-box">最大订货量
								<el-tooltip class="item" effect="dark" content="最大订货量输入空为不限制" placement="top-start">
									<img src="~/images/icon/tooltip-icon.png" class="spec-title">
								</el-tooltip>
							</div>
						</template>
						<template slot-scope='scope'>
							<el-input v-model="scope.row.maxbuyquantity" style="width:150px;margin-right:10px" size="small" @input="maxBuyQuantityInput(scope.$index)" @blur="maxBuyQuantityBlur(scope.$index)"></el-input>
							<el-radio v-model="scope.row.maxbuyquantityflag" :label="0">每天总量</el-radio>
							<el-radio v-model="scope.row.maxbuyquantityflag" :label="1">每客户每天</el-radio>
						</template>
				</el-table-column>
				<el-table-column
					prop="minbuycnt"
					label="最小起订量"
					align="center"
					min-width="150">
						<template slot-scope='scope'>
							<el-input v-model="scope.row.minbuycnt" style="width:170px" size="small" @input="minbuycntInput(scope.$index)" @blur="minbuycntBlur(scope.$index)"></el-input>
						</template>
				</el-table-column>
				<el-table-column
					prop="disabledflag"
					label="可售状态"
					align="center"
					width="160">
						<template slot-scope='scope'>
							<el-radio v-model="scope.row.disabledflag" :label="0">可售</el-radio>
							<el-radio v-model="scope.row.disabledflag" :label="1">停售</el-radio>
						</template>
				</el-table-column>
			</el-table>
			<div class="title-btn-box">
				<el-button class="btn" plain type="primary" size='small' @click="diySetClose">取消</el-button>
				<el-button class="btn" plain type="primary" size='small' @click="diySetSave">确认</el-button>
			</div>
		</el-dialog>
		<el-dialog title="新增规格名称" :before-close="addSkuClose" class="dialog-title" :visible.sync="addSkuModal" width='400px' :close-on-click-modal="false">
			<div class="reason-box">
				<span style="line-height:26px;">规格名称:</span>
				<el-select class="reason-select" size='mini' v-model="skuName">
					<el-option
					v-for="item in typeOption"
					:key="item.id"
					:label="item.name"
					:value="item.name">
					</el-option>
				</el-select>
                <el-input placeholder="请输入规格名称10个字符内" class="reason-input" :maxlength="10" @input="searchType" size='mini' v-model="skuName"></el-input>
            </div>
			<div>
				<div class="title-btn-box">
					<el-button class="btn" plain type="primary" size='small' @click="addSkuClose">取消</el-button>
					<el-button class="btn" plain type="primary" size='small' @click="addSkuSave">确认</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog :title="'添加【' + valueTitle + '】规格数值'" :before-close="addValueClose" class="dialog-title" :visible.sync="addValueModal" width='400px' :close-on-click-modal="false">
			<div class="reason-box">
				<span style="line-height:26px;">规格数值:</span>
                <el-select class="reason-select" size='mini' v-model="valueName">
                    <el-option
					v-for="item in valueOption"
					:key="item.id"
                    :label="item.name"
                    :value="item.name">
                    </el-option>
                </el-select>
                <el-input placeholder="请输入规格数值30个字符内" class="reason-input" size='mini' v-model="valueName" @input="searchValue" :maxlength="30"></el-input>
            </div>
			<div>
				<div class="title-btn-box">
					<el-button class="btn" plain type="primary" size='small' @click="addValueClose">取消</el-button>
					<el-button class="btn" plain type="primary" size='small' @click="addValueSave">确认</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog title="查看图片" class="dialog-title" :visible.sync="showImgModal" width='400px' :close-on-click-modal="false">
			<div style="text-align:center;"><w-image :src="specImg" style="width: 200px; height:200px;display:inline-block;"></w-image></div>
		</el-dialog>
		<el-dialog :title="'【'+ qrSpecName+'】编辑条形码'" class="dialog-title" :visible.sync="qrModal" width='600px' :close-on-click-modal="false">
			<div  v-if='!matchbillcenterflag' style="text-align: left;margin: 10px 0;">
				<el-button v-if="!editDisable" size='small' type="primary" style="" plain class='fx-big-btn' @click="addBarcode">新增</el-button>
			</div>
			<div class="bar-wrap">
				<div class="bar-box" v-for="(item, index) in tableDataQR" :key="item.productUnitBarCodeId">
					<div class="bar-title">条码:</div>
					<div class="bar-content">
						<el-input v-if='!matchbillcenterflag' :disabled="editDisable" type="text" @input="barcodeInput(item.barcode, index)" @mousewheel.native.prevent placeholder="最多输入13位纯数字" size='mini' maxlength="13" v-model='item.barcode'></el-input>
						<div v-if='matchbillcenterflag'>{{item.barcode}}</div>
						<i class="el-icon-search bar-search" @click="lookBarcode(item.barcode)"></i>
					</div>
					<i v-if="!editDisable" class="el-icon-minus bar-delete" @click="delItem(item, index)"></i>
				</div>
			</div>
			<div class="title-btn-box">
				<el-button class="btn" plain type="primary" size='small' @click="qrClose">取消</el-button>
				<el-button v-if='!matchbillcenterflag && !editDisable'  class="btn" plain type="primary" size='small' @click="qrSave">保存</el-button>
			</div>
		</el-dialog>
		<el-dialog title="查看条形码" class="dialog-title" :visible.sync="showCodeModal" width='400px' :close-on-click-modal="false">
			<div>
				<div style="text-align:center">
					<svg id="barcode" style="height: 82px;width: 400px;"></svg>
				</div>
				<div class="barcode-btn">
					<i class="el-icon-download bar-download" @click="downloadBar" style="margin-right:50px"></i>
					<i class="el-icon-close bar-close" @click="closeBarcode"></i>
				</div>
			</div>
		</el-dialog>
		<el-dialog title="多单位设置" class="dialog-title" :visible.sync="showUnitDialog" width='400px' :close-on-click-modal="false">
			<div class="unit-dialog">
				<div class="margin10">基础单位</div>
				<el-input class="margin10" size="mini" disabled v-model="baseUnitName"></el-input>
				<div class="margin10">
					辅助单位
					<el-checkbox style="margin-left: 20px;" v-model="useUnitFlag">启用辅助单位</el-checkbox>
				</div>
				<div class="margin10" style="display: flex;flex-direction: row;align-items: center;">
					<el-input size="mini" disabled v-model="assistUnitName" style="width:47%"></el-input>
					<div style="min-width: 20px;text-align: center;">=</div>
					<el-input size="mini" disabled v-model="ratio" style="width:48%">
						<span slot="append">{{baseUnitName}}</span>
					</el-input>
				</div>
				<div style="text-align: right;">
					<el-button size="mini" plain @click='showUnitDialog = false'>取消</el-button>
					<el-button size="mini" type="primary" @click='saveUnit'>保存</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog :title="dialogTitle" class="dialog-title" :visible.sync="showFreight" width='1000px' :close-on-click-modal="false">
			<Freight v-if='showFreight' :spceList='spceList' @saveFreight='saveFreight' @cancelFreight='cancelFreight' :orginData='orginData' :freightTypeOrgin='specFreightType' :numOrginData='numOrginData'></Freight>
		</el-dialog>
	</div>
</template>

<script>
import Freight from '@/components/freight/freight.vue'
import JsBarcode from 'jsbarcode'
import ImgUplaod from '@/components/storeSetting/saleableGoods/ImgUploadDetail.vue'
export default {
	name: 'setSpec',
	components: {
		ImgUplaod, Freight
	},
	props: {
		SKUType: {
			type: Array,
			default: () => []
		},
		SKUValue: {
			type: Array,
			default: () => []
		},
		productId: {
			type: String,
			default: ''
		},
		relAllShopFlag: Number,
		chooseShop: {
			type: Array,
			default: () => []
		},
		matchbillcenterflag: {
			type: Boolean,
			default: false
		},
		costshowflag: Number,
		productName: String,
		code: String,
		actualtimeinventoryflag: Boolean,
		editDisable: Boolean
	},
	watch: {
		SKUType (val) {
			let nameArr = []
			val.forEach(e => {
				nameArr.push(e.patname)
			})
			this.nameName = nameArr.join('-')
		},
		SKUValue: {
			handler (val) {
				this.applySkuValue(val)
			},
			immediate: true
		}
	},
	data () {
		return {
			provinceList: [
				'110000',
				'120000',
				'130000',
				'140000',
				'150000',
				'210000',
				'220000',
				'230000',
				'310000',
				'320000',
				'330000',
				'340000',
				'350000',
				'360000',
				'370000',
				'410000',
				'420000',
				'430000',
				'440000',
				'450000',
				'460000',
				'500000',
				'510000',
				'520000',
				'530000',
				'540000',
				'610000',
				'620000',
				'630000',
				'640000',
				'650000',
				'710000',
				'810000',
				'820000',
				'900000'
			],
			checkedArr: {
				110000: [],
				120000: [],
				130000: [],
				140000: [],
				150000: [],
				210000: [],
				220000: [],
				230000: [],
				310000: [],
				320000: [],
				330000: [],
				340000: [],
				350000: [],
				360000: [],
				370000: [],
				410000: [],
				420000: [],
				430000: [],
				440000: [],
				450000: [],
				460000: [],
				500000: [],
				510000: [],
				520000: [],
				530000: [],
				540000: [],
				610000: [],
				620000: [],
				630000: [],
				640000: [],
				650000: []
			},
			checkedArrHalf: {
				110000: [],
				120000: [],
				130000: [],
				140000: [],
				150000: [],
				210000: [],
				220000: [],
				230000: [],
				310000: [],
				320000: [],
				330000: [],
				340000: [],
				350000: [],
				360000: [],
				370000: [],
				410000: [],
				420000: [],
				430000: [],
				440000: [],
				450000: [],
				460000: [],
				500000: [],
				510000: [],
				520000: [],
				530000: [],
				540000: [],
				610000: [],
				620000: [],
				630000: [],
				640000: [],
				650000: []
			},
			dialogTitle: '',
			spceList: [],
			treeId: '',
			showFreight: false,
			productPlanId: '',
			baseUnitName: '',
			assistUnitName: '',
			ratio: '',
			useUnitFlag: false,
			showUnitDialog: false,
			tableData: [],
			tableHeight: '100%',
			ids: [],
			ruleForm: {
				goodsProductPlace: '',
				packList: '',
				qualityDate: '',
				venderName: '',
				storage: '',
				id: sessionStorage.getItem('goodsid')
			},
			addSkuModal: false,
			addValueModal: false,
			skuName: '',
			nameName: '',
			typeOption: [],
			valueName: '',
			valueOption: [],
			valueId: '',
			valueIndex: 0,
			valueTitle: '',
			uploadError: false,
			showImgModal: false,
			showCodeModal: false,
			specImg: '',
			qrModal: false,
			tableDataQR: [],
			qrSpecName: '',
			qrId: '',
			qrIndex: -1,
			barcode: '',
			decimal: 0,
			orginData: [],
			numOrginData: [],
			freightType: null,
			specFreightType: null,
			stopFlag: true,
			diySetModal: false,
			diySetData: [],
			diyIndex: -1
		}
	},
	created () {
		this.getOrderSystemSetting()
		this.getFreight()
	},
	methods: {
		rowShowStyle (data) {
			if (!data.row.searchShow) {
				let style = {
					'display': 'none'
				}
				return style
			} else {
				let style = {
					'display': 'table-row'
				}
				return style
			}
		},
		diySet (row, index) {
			if (this.relAllShopFlag === 1) {
				row.relProductAttrPlanShopDTOS.forEach(item => {
					item.searchShow = true
					if (item.maxBuyQuantityType === 0) {
						item.maxbuyquantity = ''
					}
				})
			} else {
				if (this.chooseShop.length === 0) {
					this.$message.error('请选择适用门店')
					return false
				}
				row.relProductAttrPlanShopDTOS.forEach(item => {
					item.searchShow = this.chooseShop.indexOf(item.shopId) !== -1
					if (item.maxBuyQuantityType === 0) {
						item.maxbuyquantity = ''
					}
				})
			}
			this.diySetData = this.$fxUtils.deepClone(row.relProductAttrPlanShopDTOS)
			this.diyIndex = index
			this.diySetModal = true
		},
		diySetClose () {
			this.diySetModal = false
		},
		diySetSave () {
			for (let i = 0; i < this.diySetData.length; i++) {
				let e = this.diySetData[i]
				if (e.searchShow) {
					if (e.minbuycnt === '') {
						this.$message.error('【' + e.shopname + '】的最小起订量不能为空！')
						return false
					}
					if (+e.minbuycnt < 0 || +e.minbuycnt > 9999) {
						this.$message.error('【' + e.shopname + '】的最小起订量在0~9999范围内！')
						return false
					}
				}
			}
			this.tableData[this.diyIndex].relProductAttrPlanShopDTOS = this.diySetData
			this.diySetModal = false
		},
		cancelFreight () {
			this.showFreight = false
		},
		setFreightMuti () {
			if (this.ids.length === 0) {
				this.$message.warning('请勾选规格数值！')
				return false
			}
			this.numOrginData = []
			this.specFreightType = 0
			this.spceList = this.ids
			this.dialogTitle = '批量设置运费 已选（' + this.ids.length + '）个规格'
			this.showFreight = true
		},
		saveFreight () {
			this.showFreight = false
			this.$emit('refreshData')
		},
		getFreight () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/freight/detail/get`
			}).then(res => {
				if (res.result) {
					let list = res.data.freightDetailDTOList || []
					this.stopFlag = res.data.stopFlag
					this.freightType = res.data.freightType
					if (list.length > 0) {
						list.forEach(item => {
							item.provinces = item.provinces.split(',')
							let nameArr = item.areaname.split(',')
							item.showname = item.areaname
							if (nameArr.length > 20) {
								item.showname = nameArr.slice(0, 21).join(',') + '...'
							}
						})
					}
					this.orginData = list
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		showFreightClick (id) {
			let params = {
				productAttrplanid: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/productattrplan/freight/detail/get`,
				data: params
			}).then(res => {
				if (res.result) {
					this.spceList = [id]
					let list = res.data.freightDetailDTOList || []
					this.specFreightType = res.data.freightType
					if (list.length > 0) {
						list.forEach(item => {
							item.checkedArr = item.fullSelectedArea
							item.checkedArrHalf = item.halfSelectedArea
							let list = this.provinceList
							let checkArr = []
							let arr = []
							let checkedArrHalf = []
							for (let i = 0; i < list.length; i++) {
								if (item.checkedArr[list[i]]) {
									if (item.checkedArr[list[i]].length > 0) {
										arr.push(list[i])
									}
									checkArr = checkArr.concat(item.checkedArr[list[i]])
								}
								if (item.checkedArrHalf[list[i]]) {
									checkedArrHalf = checkedArrHalf.concat(item.checkedArrHalf[list[i]])
								}
							}
							item.updateFullSelectedArea = checkArr
							item.updateHalfSelectedArea = checkedArrHalf
							item.provinces = item.provinces.split(',')
							let nameArr = item.areaname.split(',')
							item.showname = item.areaname
							if (nameArr.length > 20) {
								item.showname = nameArr.slice(0, 21).join(',') + '...'
							}
						})
					}
					if (res.data.freightType === 2) {
						this.numOrginData = JSON.parse(JSON.stringify(list))
					} else {
						this.numOrginData = []
					}
					this.dialogTitle = '设置运费'
					this.showFreight = true
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		saveUnit () {
			let params = {
				useUnitFlag: this.useUnitFlag ? 1 : 0,
				productPlanId: this.productPlanId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/saveUseUnitFlagForMatch`,
				data: params
			}).then(res => {
				if (res.result) {
					this.showUnitDialog = false
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		showUnitClick (id) {
			let params = {
				id: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/findUnitForMatch`,
				data: params
			}).then(res => {
				if (res.result) {
					this.productPlanId = id
					this.baseUnitName = res.data.baseUnitName
					this.assistUnitName = res.data.assistUnitName
					this.useUnitFlag = res.data.useUnitFlag === 1
					this.ratio = res.data.ratio
					this.showUnitDialog = true
				}
			})
		},
		setData () {
			return new Promise(resolve => {
				resolve(this.tableDataQR)
			})
		},
		// 编辑二维码
		qrClick (name, id, index) {
			this.qrSpecName = name
			this.qrId = id
			this.qrIndex = index
			let params = {
				productPlanId: id,
				id: this.productId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/productBarcode/list`,
				data: params
			}).then(res => {
				if (res.result) {
					this.qrModal = true
					this.tableDataQR = res.data
					this.setData().then(res => {
						// res.forEach((e, index) => {
						// 	JsBarcode('#barcode' + index, e.barcode, {
						// 		format: 'CODE128', // 条形码的格式
						// 		// lineColor: '#0aa', // 线条颜色
						// 		// width: 4, // 线宽
						// 		height: 20, // 条码高度
						// 		displayValue: true // 是否显示文字信息
						// 	})
						// })
					})
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		showBar () {
			return new Promise(resolve => {
				this.showCodeModal = true
				resolve()
			})
		},
		lookBarcode (code) {
			if (code === '') {
				return false
			}
			this.barcode = code
			this.showBar().then(res => {
				JsBarcode('#barcode', code, {
					format: 'CODE128', // 条形码的格式
					// lineColor: '#0aa', // 线条颜色
					// width: 4, // 线宽
					height: 60, // 条码高度
					displayValue: true // 是否显示文字信息
				})
			})
		},
		downloadBar () {
			const req = new XMLHttpRequest()
			let _this = this
			req.open('POST', `${this.$fxBaseApi.urlQIVShop}/productBarcode/export`, true)
			req.responseType = 'blob'
			req.setRequestHeader('Content-Type', 'application/json')
			req.setRequestHeader('pname', 'bc2ff5388144d30e137b28acafd39795')
			req.setRequestHeader('shiroSession', window.sessionStorage.getItem('shiroSession'))
			req.onload = function () {
				const data = req.response
				const blob = new Blob([data])
				const blobUrl = window.URL.createObjectURL(blob)
				_this.download(blobUrl)
			}
			req.send(this.barcode)
		},
		download (blobUrl) {
			const a = document.createElement('a')
			a.style.display = 'none'
			a.download = this.barcode + '.png'
			a.href = blobUrl
			a.click()
		},
		closeBarcode () {
			this.showCodeModal = false
		},
		barcodeInput (item, index) {
			this.tableDataQR[index].barcode = this.tableDataQR[index].barcode.replace(/[^\d]/g, '')
			item = item.replace(/[^\d]/g, '')
			// if (item === '') {
			// 	document.querySelector('#barcode' + index).innerHTML = ''
			// } else {
			// 	JsBarcode('#barcode' + index, item, {
			// 		format: 'CODE128', // 条形码的格式
			// 		// lineColor: '#0aa', // 线条颜色
			// 		// width: 4, // 线宽
			// 		height: 20, // 条码高度
			// 		displayValue: true // 是否显示文字信息
			// 	})
			// }
		},
		qrClose () {
			this.qrModal = false
		},
		// 保存二维码
		qrSave () {
			if (this.tableDataQR.length === 0) {
				this.$message.error('商品条形码不能为空')
				return false
			}
			let barcodes = []
			for (var i = 0; i < this.tableDataQR.length; i++) {
				if (this.tableDataQR[i].barcode === '') {
					this.$message.error('商品条形码不能为空')
					return false
				} else {
					barcodes.push(this.tableDataQR[i].barcode)
				}
			}
			let params = {
				barcodes: barcodes,
				id: this.qrId,
				productId: this.productId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/productBarcode/saveOrUpdate`,
				data: params
			}).then(res => {
				if (res.result) {
					this.tableData[this.qrIndex].barcodecount = this.tableDataQR.length
					this.qrModal = false
					this.$message.success('保存成功')
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		// 新增
		addBarcode () {
			let add = { barcode: '' }
			this.tableDataQR.push(add)
		},
		// 删除条形码
		delItem (item, index) {
			// if (!item.hasOwnProperty('productUnitBarCodeId')) {
			// 	this.tableData.splice(index, 1)
			// } else {
			this.$confirm(`是否要删除该条形码?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				let params = {
					productUnitBarCodeId: item.productUnitBarCodeId
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIV}/shop/productBarcode/remove`,
					data: params
				}).then(res => {
					if (res.result === true) {
						this.tableDataQR.splice(index, 1)
						this.tableDataQR.forEach((e, index) => {
							if (e.barcode) {
								JsBarcode('#barcode' + index, e.barcode, {
									format: 'CODE128', // 条形码的格式
									// lineColor: '#0aa', // 线条颜色
									// width: 4, // 线宽
									height: 20, // 条码高度
									displayValue: true // 是否显示文字信息
								})
							} else {
								JsBarcode('#barcode' + index, ' ', {
									format: 'CODE128', // 条形码的格式
									// lineColor: '#0aa', // 线条颜色
									// width: 4, // 线宽
									height: 0, // 条码高度
									displayValue: true // 是否显示文字信息
								})
							}
						})
						this.tableData[this.qrIndex].barcodecount = this.tableDataQR.length
						this.$message.success('删除成功')
						// this.$emit('cancel', false)
					} else {
						this.$message.error(res.msg)
					}
				})
			}).catch(() => {

			})
			// }
		},
		// 明细编号
		codeInput (index) {
			this.tableData[index].code = this.tableData[index].code.replace(/\\|\'|[\u4E00-\u9FA5]/g, '')
		},
		// 销售价失焦
		priceBlur (index) {
			this.tableData[index].price = this.tableData[index].price ? this.$fxUtils.toFixedSHW(this.tableData[index].price, 2) : ''
		},
		costpriceBlur (index) {
			this.tableData[index].costprice = this.$fxUtils.toFixedSHW(this.tableData[index].costprice, 2)
		},
		minbuycntBlur (index) {
			if (this.diySetData[index].minbuycnt !== '') {
				this.diySetData[index].minbuycnt = +this.diySetData[index].minbuycnt
			}
		},
		maxBuyQuantityBlur (index) {
			if (this.diySetData[index].maxbuyquantity !== '') {
				this.diySetData[index].maxBuyQuantityType = 1
				this.diySetData[index].maxbuyquantity = +this.diySetData[index].maxbuyquantity
			} else {
				this.diySetData[index].maxBuyQuantityType = 0
			}
			if (this.diySetData[index].maxbuyquantity > 1000000) {
				this.diySetData[index].maxbuyquantity = 999999
			}
		},
		maxBuyQuantityInput (index) {
			this.diySetData[index].maxbuyquantity = this.diySetData[index].maxbuyquantity.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			this.diySetData[index].maxbuyquantity = this.diySetData[index].maxbuyquantity.replace(/^\./g, '')// 验证第一个字符是数字而不是
			this.diySetData[index].maxbuyquantity = this.diySetData[index].maxbuyquantity.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			this.diySetData[index].maxbuyquantity = this.diySetData[index].maxbuyquantity.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
			switch (this.decimal) {
			case 0:
				this.diySetData[index].maxbuyquantity = this.diySetData[index].maxbuyquantity.replace(/[^\d]/g, '')
				break
			case 1:
				this.diySetData[index].maxbuyquantity = this.diySetData[index].maxbuyquantity.replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3')
				break
			case 2:
				this.diySetData[index].maxbuyquantity = this.diySetData[index].maxbuyquantity.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
				break
			case 3:
				this.diySetData[index].maxbuyquantity = this.diySetData[index].maxbuyquantity.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, '$1$2.$3')
				break
			case 4:
				this.diySetData[index].maxbuyquantity = this.diySetData[index].maxbuyquantity.replace(/^(\-)*(\d+)\.(\d\d\d\d).*$/, '$1$2.$3')
				break
			}
			if (this.diySetData[index].maxbuyquantity.indexOf('.') !== -1) {
				if (this.diySetData[index].maxbuyquantity.split('.')[0] === '') {
					this.diySetData[index].maxbuyquantity = ''
				}
			}
		},
		// 最小起订量失焦
		minbuycntInput (index) {
			this.diySetData[index].minbuycnt = this.diySetData[index].minbuycnt.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			this.diySetData[index].minbuycnt = this.diySetData[index].minbuycnt.replace(/^\./g, '')// 验证第一个字符是数字而不是
			this.diySetData[index].minbuycnt = this.diySetData[index].minbuycnt.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			this.diySetData[index].minbuycnt = this.diySetData[index].minbuycnt.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
			switch (this.decimal) {
			case 0:
				this.diySetData[index].minbuycnt = this.diySetData[index].minbuycnt.replace(/[^\d]/g, '')
				break
			case 1:
				this.diySetData[index].minbuycnt = this.diySetData[index].minbuycnt.replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3')
				break
			case 2:
				this.diySetData[index].minbuycnt = this.diySetData[index].minbuycnt.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
				break
			case 3:
				this.diySetData[index].minbuycnt = this.diySetData[index].minbuycnt.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, '$1$2.$3')
				break
			case 4:
				this.diySetData[index].minbuycnt = this.diySetData[index].minbuycnt.replace(/^(\-)*(\d+)\.(\d\d\d\d).*$/, '$1$2.$3')
				break
			}
			if (this.diySetData[index].minbuycnt.indexOf('.') !== -1) {
				if (this.diySetData[index].minbuycnt.split('.')[0] === '') {
					this.diySetData[index].minbuycnt = ''
				}
			}
			// this.tableData[index].minbuycnt = this.$fxUtils.toFixedSHW(this.tableData[index].minbuycnt, 2)
		},
		minbuycntBlur2 (index) {
			if (this.tableData[index].minbuycnt !== '') {
				this.tableData[index].minbuycnt = +this.tableData[index].minbuycnt
			}
		},
		maxBuyQuantityBlur2 (index) {
			if (this.tableData[index].maxBuyQuantity !== '') {
				this.tableData[index].maxBuyQuantityType = 1
				this.tableData[index].maxBuyQuantity = +this.tableData[index].maxBuyQuantity
			} else {
				this.tableData[index].maxBuyQuantityType = 0
			}
			if (this.tableData[index].maxBuyQuantity > 1000000) {
				this.tableData[index].maxBuyQuantity = 999999
			}
		},
		maxBuyQuantityInput2 (index) {
			this.tableData[index].maxBuyQuantity = this.tableData[index].maxBuyQuantity.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			this.tableData[index].maxBuyQuantity = this.tableData[index].maxBuyQuantity.replace(/^\./g, '')// 验证第一个字符是数字而不是
			this.tableData[index].maxBuyQuantity = this.tableData[index].maxBuyQuantity.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			this.tableData[index].maxBuyQuantity = this.tableData[index].maxBuyQuantity.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
			switch (this.decimal) {
			case 0:
				this.tableData[index].maxBuyQuantity = this.tableData[index].maxBuyQuantity.replace(/[^\d]/g, '')
				break
			case 1:
				this.tableData[index].maxBuyQuantity = this.tableData[index].maxBuyQuantity.replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3')
				break
			case 2:
				this.tableData[index].maxBuyQuantity = this.tableData[index].maxBuyQuantity.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
				break
			case 3:
				this.tableData[index].maxBuyQuantity = this.tableData[index].maxBuyQuantity.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, '$1$2.$3')
				break
			case 4:
				this.tableData[index].maxBuyQuantity = this.tableData[index].maxBuyQuantity.replace(/^(\-)*(\d+)\.(\d\d\d\d).*$/, '$1$2.$3')
				break
			}
			if (this.tableData[index].maxBuyQuantity.indexOf('.') !== -1) {
				if (this.tableData[index].maxBuyQuantity.split('.')[0] === '') {
					this.tableData[index].maxBuyQuantity = ''
				}
			}
		},
		// 最小起订量失焦
		minbuycntInput2 (index) {
			this.tableData[index].minbuycnt = this.tableData[index].minbuycnt.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			this.tableData[index].minbuycnt = this.tableData[index].minbuycnt.replace(/^\./g, '')// 验证第一个字符是数字而不是
			this.tableData[index].minbuycnt = this.tableData[index].minbuycnt.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			this.tableData[index].minbuycnt = this.tableData[index].minbuycnt.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
			switch (this.decimal) {
			case 0:
				this.tableData[index].minbuycnt = this.tableData[index].minbuycnt.replace(/[^\d]/g, '')
				break
			case 1:
				this.tableData[index].minbuycnt = this.tableData[index].minbuycnt.replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3')
				break
			case 2:
				this.tableData[index].minbuycnt = this.tableData[index].minbuycnt.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
				break
			case 3:
				this.tableData[index].minbuycnt = this.tableData[index].minbuycnt.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, '$1$2.$3')
				break
			case 4:
				this.tableData[index].minbuycnt = this.tableData[index].minbuycnt.replace(/^(\-)*(\d+)\.(\d\d\d\d).*$/, '$1$2.$3')
				break
			}
			if (this.tableData[index].minbuycnt.indexOf('.') !== -1) {
				if (this.tableData[index].minbuycnt.split('.')[0] === '') {
					this.tableData[index].minbuycnt = ''
				}
			}
			// this.tableData[index].minbuycnt = this.$fxUtils.toFixedSHW(this.tableData[index].minbuycnt, 2)
		},
		inventoryBlur (index) {
			this.tableData[index].inventory = this.tableData[index].inventory.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			this.tableData[index].inventory = this.tableData[index].inventory.replace(/^\./g, '')// 验证第一个字符是数字而不是
			this.tableData[index].inventory = this.tableData[index].inventory.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			this.tableData[index].inventory = this.tableData[index].inventory.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
			switch (this.decimal) {
			case 0:
				this.tableData[index].inventory = this.tableData[index].inventory.replace(/(^[0]|[^\d])/g, '')
				break
			case 1:
				this.tableData[index].inventory = this.tableData[index].inventory.replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3')
				break
			case 2:
				this.tableData[index].inventory = this.tableData[index].inventory.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
				break
			case 3:
				this.tableData[index].inventory = this.tableData[index].inventory.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, '$1$2.$3')
				break
			case 4:
				this.tableData[index].inventory = this.tableData[index].inventory.replace(/^(\-)*(\d+)\.(\d\d\d\d).*$/, '$1$2.$3')
				break
			}
			if (this.tableData[index].inventory.indexOf('.') !== -1) {
				if (this.tableData[index].inventory.split('.')[0] === '') {
					this.tableData[index].inventory = ''
				}
			}
		},
		// 重量失焦
		weightBlur (index) {
			this.tableData[index].weight = this.$fxUtils.toFixedSHW(this.tableData[index].weight, 3)
		},
		// 选择默认
		changeDefault (i) {
			this.tableData.forEach((e, index) => {
				if (i === index) {
					e.defaultflag = true
				} else {
					e.defaultflag = false
				}
			})
		},
		applySkuValue (val) {
			this.tableData = Array.isArray(val) ? val.slice() : []
		},
		refreshSeqnum () {
			this.tableData.forEach((item, index) => {
				item.seqnum = index + 1
			})
		},
		moveSpec (index, type) {
			if (this.editDisable) {
				return
			}
			const list = this.tableData
			if (type === 'top') {
				if (index === 0) {
					return
				}
				const item = list.splice(index, 1)[0]
				list.unshift(item)
			} else if (type === 'up') {
				if (index === 0) {
					return
				}
				const item = list.splice(index, 1)[0]
				list.splice(index - 1, 0, item)
			} else if (type === 'down') {
				if (index === list.length - 1) {
					return
				}
				const item = list.splice(index, 1)[0]
				list.splice(index + 1, 0, item)
			} else if (type === 'bottom') {
				if (index === list.length - 1) {
					return
				}
				const item = list.splice(index, 1)[0]
				list.push(item)
			}
			this.refreshSeqnum()
			this.tableData = list.slice()
		},
		// 规格图片预览
		preview (url) {
			this.specImg = url
			this.showImgModal = true
		},
		// 删除规格图片
		updateImg (index) {
			this.tableData[index].url = ''
		},
		// 批量设置可售停售
		setDisableFlag (type) {
			if (this.ids.length === 0) {
				this.$message.warning('请勾选规格数值！')
				return false
			}
			this.tableData.forEach(e => {
				if (e.checked) {
					e.disabledflag = type === 1
				}
			})
			this.$message.success('勾选【' + this.ids.length + '】个规格已设置' + (type === 0 ? '可售' : '停售') + '状态。保存才可生效！')
		},
		// 新增规格名称
		addSkuSave () {
			if (this.skuName === '' || this.skuName.trim().length > 10) {
				this.$message.error('请输入1~10个字范围内的规格名称！')
				return false
			}
			for (let i = 0; i < this.SKUType.length; i++) {
				if (this.skuName.trim() === this.SKUType[i].patname) {
					this.$message.error('规格名称不能重复！')
					return false
				}
			}
			const logger = this.$fxLogger.createInfo('goods.saleable_goods.specAdd', { name: '【商品名称：' + this.productName + '】【商品规格：' + this.code + '】新建【规格名称：' + this.skuName.trim() + '】' })
			let params = {
				attrvalueName: this.skuName.trim(),
				id: this.productId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/product/saveAttrtype`,
				data: params,
				logger

			}).then(res => {
				if (res.result) {
					this.$message.success('保存成功！')
					this.addSkuClose()
					this.$emit('addSku', res.data.name, res.data.id)
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		addSkuClose () {
			this.addSkuModal = false
			this.skuName = ''
			this.typeOption = []
		},
		addSpecSKU () {
			if (this.productId === '') {
				this.$confirm('请先保存商品信息后，再新建规格名称，是否保存商品信息？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false
				}).then(() => {
					this.$emit('saveNew', 2)
				}).catch(() => {})
			} else {
				for (let i = 0; i < this.SKUType.length; i++) {
					if (this.SKUType[i].specvalue.length === 0) {
						this.$message.error('请添加【' + this.SKUType[i].patname + '】的规格数值后，再添加新的规格名称！')
						return false
					}
				}
				this.addSkuModal = true
			}
		},
		searchType () {
			let params = {
				name: this.skuName
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/product/findAllAttrtype`,
				data: params
			}).then(res => {
				if (res.result) {
					this.typeOption = res.data
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		// 新增规格数值
		addSKUValue (id, index, name) {
			this.valueId = id
			this.valueIndex = index
			this.valueTitle = name
			this.addValueModal = true
		},
		addValueClose () {
			this.addValueModal = false
			this.valueName = ''
			this.valueOption = []
		},
		addValueSave () {
			if (this.valueName === '' || this.valueName.trim().length > 30) {
				this.$message.error('请输入1~30个字范围内的规格数值！')
				return false
			}
			if ((this.valueIndex === 1 && this.SKUType[1].specvalue.length === 0) || (this.valueIndex === 2 && this.SKUType[2].specvalue.length === 0)) {
				this.$confirm('添加规格数值后，会先清除现有规格明细列，然后重新创建规格信息，会影响小程序商品的售卖，是否继续？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false
				}).then(() => {
					this.addValueHandle()
				}).catch(() => {})
			} else {
				this.addValueHandle()
			}
		},
		addValueHandle () {
			let params = {
				attrvalueName: this.valueName.trim(),
				id: this.productId,
				attrtypeid: this.valueId,
				attrtypenum: this.valueIndex + 1
			}
			const logger = this.$fxLogger.createInfo('goods.saleable_goods.specValueAdd', { name: '【商品名称：' + this.productName + '】【商品规格：' + this.code + '】【规格名称：' + this.valueTitle + '】新建【规格数值：' + this.valueName.trim() + '】' })
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/product/saveAttrplan`,
				data: params,
				logger
			}).then(res => {
				if (res.result) {
					this.$message.success('保存成功！')
					this.addValueClose()
					this.$emit('refreshData')
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		searchValue () {
			let params = {
				name: this.valueName,
				attrtypeid: this.valueId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/product/findAllAttrplan`,
				data: params
			}).then(res => {
				if (res.result) {
					this.valueOption = res.data
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		// 删除规格数值
		deleteValue (id, num, tid, index, specname, specvalue) {
			if (this.SKUType.length > 1 && num === 1) {
				this.$confirm('删除规格数值后，会先清除现有规格明细列，然后重新创建规格信息，会影响小程序商品的售卖，是否继续？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false
				}).then(() => {
					this.deleteValueHandle(id, tid, index, specname, specvalue)
				}).catch(() => {})
			} else {
				this.deleteValueHandle(id, tid, index, specname, specvalue)
			}
		},
		deleteValueHandle (id, tid, index, specname, specvalue) {
			let params = {
				attrvalueid: id,
				id: this.productId,
				attrtypeid: tid,
				attrtypenum: index + 1
			}
			const logger = this.$fxLogger.createInfo('goods.saleable_goods.specValueDel', { name: '【商品名称：' + this.productName + '】【商品规格：' + this.code + '】【规格名称：' + specname + '】删除【规格数值：' + specvalue + '】' })
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/product/delAttrValue`,
				data: params,
				logger
			}).then(res => {
				if (res.result) {
					this.$message.success('删除成功！')
					this.$emit('refreshData')
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		// 删除规格名称
		deleteSKU (id, name) {
			this.$confirm('删除规格名称后，会先清除现有规格明细列，然后重新创建规格信息，会影响小程序商品的售卖，是否继续？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				let params = {
					id: this.productId,
					attrtypeid: id
				}
				const logger = this.$fxLogger.createInfo('goods.saleable_goods.specDel', { name: '【商品名称：' + this.productName + '】【商品规格：' + this.code + '】删除【规格名称：' + name + '】' })
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/product/delAttrplanType`,
					data: params,
					logger
				}).then(res => {
					if (res.result) {
						this.$message.success('删除成功！')
						this.$emit('refreshData')
					} else {
						this.$message.error(res.msg)
					}
				}).catch(err => {
					this.$message.error(err.msg)
				})
			}).catch(() => {})
		},
		handleSelectionChange (value) {
			let a = value
			this.ids = []
			for (let i = 0; i < a.length; i++) {
				this.ids.push(a[i].productid)
			}
			this.tableData.filter(e => {
				if (value.indexOf(e) > -1) {
					e.checked = true
				} else {
					e.checked = false
				}
			})
		},
		tableRowClassName ({ row, rowIndex }) {
			if (row.checked) {
				return 'check-row'
			}
			return ''
		},
		getInfo () {
			return this.ruleForm
		},
		resetForm () {
			this.ruleForm.goodsProductPlace = ''
			this.ruleForm.packList = ''
			this.ruleForm.qualityDate = ''
			this.ruleForm.venderName = ''
			this.ruleForm.storage = ''
		},
		getOrderSystemSetting () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/getOrderSystemSetting`
			}).then(res => {
				if (res.result) {
					this.decimal = res.data.orderdecimalcount
				} else {
					this.$message.error(res.msg)
				}
			}).catch((res) => {
				this.$message.error(res.msg)
			})
		}
	}
}
</script>
<style lang="stylus">
.unit-dialog{
	display :flex;
	flex-direction :column
	.margin10{
		margin-bottom :10px
	}
}
.price-input {
	.el-input__inner {
		border: 0
	}
}
	.el-table .check-row {
		background: #F3F7FF;
	}
</style>
<style lang="stylus" scoped>
.spec-info-body {
	flex: 1
	text-align left
	p {
		height: 20px
		text-align: left
		line-height 20px
		font-size 16px
		border-left 4px solid var(--fx-primary-color)
		padding-left 8px
		margin 20px 0
		// font-weight 700
	}
	.set-box {
		display: flex
		padding-left: 15px;
		color: #333;
		font-size: 14px;
		.spec-btn {
			width: 120px;
			height: 30px;
			line-height: 30px;
			text-align: center;
			border: 1px solid var(--fx-primary-color);
			border-radius: 4px;
			color: var(--fx-primary-color);
			cursor: pointer
		}
		.spec-btn-disabled {
			width: 120px;
			height: 30px;
			line-height: 30px;
			text-align: center;
			border: 1px solid #999;
			border-radius: 4px;
			color: #999;
			cursor: not-allowed
		}
		.sku-box {
			margin-left: 40px
			display: flex;
			align-items: center
			&.sku-match-box {
				margin: 0 40px 0 0
			}
			.sku-title {
				padding-top: 5px
				max-width: 65px;
				font-size: 16px;
				flex-shrink: 0
			}
			.sku-set-box {
				display: flex;
				align-items: center;
				.spec-btn {
					margin-left: 15px;
				}
			}
			.sku-name-box {
				padding-left: 15px;
				box-sizing: border-box;
				max-width: 250px;
				&>div {
					display: inline-block;
					margin-top: 10px;
					margin-right: 10px;
					padding: 5px 12px;
					border: 1px solid #CCCCCC;
					border-radius: 4px;
					position: relative
					.delete-sku {
						position: absolute;
						top: -7px;
						right: -8px;
						color: #F56C6C;
						cursor: pointer;
						font-size: 14px;
						background-color: #fff;
					}
				}
			}
		}
	}
	.features-btn-box {
		margin-bottom: 10px;
		padding: 0 10px;
		display flex
	}
	.title-box {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.spec-title {
		width: 14px;
		height: 14px;
		cursor: pointer;
		margin: -1px 0 0 4px;
	}
	.table-box {
		font-size: 14px;
		color: #333
		.spec-img {
			width: 55px;
			height: 55px;
			display: inline-block;
		}
		.table-weight {
			display:flex;
			align-items: center;
			span {
				width:20px;
				margin-left:5px;
				flex-shrink: 0;
			}
		}
		.table-price {
			display:flex;
			justify-content: center;
			align-items: center;
			.price-input {
				width: 124px;
				height: 32px;
				line-height: 32px;
				border: 1px solid #ebeef5;
				display: flex;
				.price-title {
					display: inline-block;
					width: 47px;
					text-align: center;
					border-right: 1px solid #ebeef5;
					flex-shrink: 0;
				}
				.el-input__inner {
					border: 0
				}
			}
			span {
				width:20px;
				margin-left:5px;
				flex-shrink: 0;
			}
		}
		.qrcode-btn {
			width: 110px;
			height: 32px;
			line-height: 32px;
			border: 1px solid #ebeef5;
			text-align: center;
			cursor: pointer;
			.qrcode-color {
				color: var(--fx-primary-color);
			}
		}
		.seqnum-actions {
			display: flex;
			align-items: center;
			justify-content: center;
			i {
				font-size: 16px;
				color: var(--fx-primary-color);
				cursor: pointer;
				margin: 0 4px;
				&.is-disabled {
					color: #c0c4cc;
					cursor: not-allowed;
				}
			}
		}
	}
	.bar-wrap {
		max-height: 300px;
		overflow-y: auto;
		.bar-box {
			display: flex;
			align-items: center;
			padding-right: 20px;
			margin-bottom: 15px;
			.bar-title {
				width: 80px;
				text-align: right;
				margin-right: 10px;
				flex-shrink: 0
			}
			.bar-content {
				flex: 1;
				min-width: 0;
				position: relative;
				.bar-search {
					position: absolute;
					right: 10px;
					top: 7px;
					cursor: pointer;
				}
			}
			.bar-delete {
				margin-left: 10px;
				flex-shrink: 0;
				color: #000;
				font-weight: bold;
				cursor: pointer
			}
		}
	}
	.barcode-btn {
		text-align:center
		margin-top: 10px;
		i {
			font-size: 25px;
			color: #000;
			cursor: pointer
		}
	}
	.title-btn-box{
		height:40px;
		padding:10px;
		box-sizing:border-box;
		text-align:center
		.btn{
			width:130px;
		}
	}
	.reason-box{
        // margin-left :100px;
        height:40px;
        position:relative
    }
    .reason-select{
        position :absolute;
        left:70px;
        top:0px;
        width:250px;
    }
    .reason-input{
        width:220px;
        position :absolute;
        left:71px;
        top:1px;
    }
    .reason-input >>>.el-input__inner {
        height :26px;
        border:none
    }
}
</style>
